import { Flex, Icon, Typography } from '@aloft/toolkit-sui';

import { TkOrderListField, Tkv2SortState } from './types.ts';
import { getTkv2SortIcon } from './utils/getTkv2SortIcon.ts';

export const Tkv2OrderTableHeaderItem = ({
  title,
  field,
  sortState,
  onClick,
}: {
  title: string;
  field: TkOrderListField;
  sortState: Tkv2SortState;
  onClick: (field: TkOrderListField) => void;
}) => (
  <Flex
    gap=".25rem"
    paddingY=".5rem"
    alignItems="center"
    onClick={() => onClick(field)}
    cursor="pointer"
  >
    <Typography variant="h5" __dangerDoNotUseSx={{ fontSize: '12px' }}>
      {title}
    </Typography>
    <Icon
      icon={getTkv2SortIcon(field, sortState)}
      size="sm"
      __styleDoNotUse={{ width: '12px', height: '12px' }}
    />
  </Flex>
);
